<template>
  <div v-if="openadvanceSearch" class="advance-search-container1">
    <slot name="advance_search_items"></slot>

    <!-- row button-->
    <v-row class="mb-1 mt-2">
      <v-col sm="12 text-right">
        <x-button
          buttonText="Clear Search"
          :outline="true"
          :color="primaryColor"
          :data-test-id="`${parentDataTestId}__clear-search-btn`"
          @click="() => this.$emit('cancelSearch')"
        />
        <x-button
          buttonText="Search"
          class="ml-2"
          :color="primaryColor"
          :data-test-id="`${parentDataTestId}__search-btn`"
          @click="searchData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'AdvanceSearchForm',
  props: {
    openadvanceSearch: Boolean,
    primaryColor: String,
    parentDataTestId: {
      required: true,
      type: String
    }
  },
  methods: {
    searchData() {
      this.$emit('searchData');
    }
  }
};
</script>
